import { render } from "./TruckOrWareEntries.vue?vue&type=template&id=52d2dba2&scoped=true"
import script from "./TruckOrWareEntries.vue?vue&type=script&lang=js"
export * from "./TruckOrWareEntries.vue?vue&type=script&lang=js"

import "./TruckOrWareEntries.vue?vue&type=style&index=0&id=52d2dba2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52d2dba2"]])

export default __exports__